// Generated by purs version 0.13.8
"use strict";
var Unsafe_Coerce = require("../Unsafe.Coerce/index.js");
var string = Unsafe_Coerce.unsafeCoerce;
module.exports = {
    string: string
};
